import type { IconProps as Props } from './types';

export const IconEmailEnvelope = ({
  className,
  width = '1em',
  height = '1em',
  stroke = 'var(--text-neutral-faded)',
  fill = 'none',
  ...rest
}: Props) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      {...rest}
    >
      <g id="Email Envelope">
        <path
          id="Path"
          d="M14.5 4.5V11.5C14.5 11.8978 14.342 12.2794 14.0607 12.5607C13.7794 12.842 13.3978 13 13 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V4.5M14.5 4.5C14.5 4.10218 14.342 3.72064 14.0607 3.43934C13.7794 3.15804 13.3978 3 13 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5M14.5 4.5V4.662C14.5 4.9181 14.4345 5.16994 14.3096 5.39353C14.1848 5.61712 14.0047 5.80502 13.7867 5.93933L8.78667 9.016C8.55014 9.16169 8.2778 9.23883 8 9.23883C7.7222 9.23883 7.44986 9.16169 7.21333 9.016L2.21333 5.94C1.99528 5.80569 1.81525 5.61779 1.69038 5.3942C1.56551 5.1706 1.49997 4.91876 1.5 4.66267V4.5"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const IconEmailEnvelopeNew = ({
  className,
  width = '48',
  height = '48',
  stroke = 'currentColor',
  strokeWidth = '2.5',
  fill = 'none',
  ...props
}: Props) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.5 13.5V34.5C43.5 35.6935 43.0259 36.8381 42.182 37.682C41.3381 38.5259 40.1935 39 39 39H9C7.80653 39 6.66193 38.5259 5.81802 37.682C4.97411 36.8381 4.5 35.6935 4.5 34.5V13.5M43.5 13.5C43.5 12.3065 43.0259 11.1619 42.182 10.318C41.3381 9.47411 40.1935 9 39 9H9C7.80653 9 6.66193 9.47411 5.81802 10.318C4.97411 11.1619 4.5 12.3065 4.5 13.5M43.5 13.5V13.986C43.5001 14.7543 43.3035 15.5098 42.9289 16.1806C42.5543 16.8514 42.0142 17.4151 41.36 17.818L26.36 27.048C25.6504 27.4851 24.8334 27.7165 24 27.7165C23.1666 27.7165 22.3496 27.4851 21.64 27.048L6.64 17.82C5.98584 17.4171 5.44574 16.8534 5.07114 16.1826C4.69654 15.5118 4.49991 14.7563 4.5 13.988V13.5"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
